// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2cu0P","title":"Info_title__fgYjE","selects":"Info_selects__O97eb","requiredAsterisk":"Info_requiredAsterisk__3UFpv"};